@if (notification()) {
	<div class="notification-banner" [ngClass]="bannerClasses()">
		<div class="banner-icon">
			@if (notification()?.type === 'info') {
				<i class="bi bi-info-circle"></i>
			} @else {
				<span [innerHTML]="getIconSVG()"></span>
			}
		</div>
		<div class="banner-content">
			@if (notification()!.label) {
				<span class="banner-label">{{ notification()!.label }}</span>
			}
			<span class="banner-message">{{ notification()!.message }}</span>
			@if (notification()!.detail) {
				<span class="banner-detail">{{ notification()!.detail }}</span>
			}
		</div>
		<button class="banner-dismiss" (click)="dismiss()" title="Dismiss">
			<i class="bi bi-x text-xl"></i>
		</button>
	</div>
}
